import { render } from "./affiliateSystem.vue?vue&type=template&id=4efbfd24&scoped=true"
import script from "./affiliateSystem.vue?vue&type=script&lang=js"
export * from "./affiliateSystem.vue?vue&type=script&lang=js"

import "./affiliateSystem.vue?vue&type=style&index=0&id=4efbfd24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efbfd24"]])

export default __exports__